/**
 * Copyright (c) Microsoft. All rights reserved.
 */

// learning section links
export const languageDocsLink = 'https://aka.ms/LanguageDocs';
export const codeSamplesJavaLink = 'https://aka.ms/language-sdks-java';
export const codeSamplesCsharpLink = 'https://aka.ms/language-sdks-csharp';
export const codeSamplesPythonLink = 'https://aka.ms/language-sdks-python';
export const codeSamplesJavaScriptLink = 'https://aka.ms/language-sdks-javascript';

// Prebuilt demo card links
export const learnMoreLink =
    'https://docs.microsoft.com/learn/modules/describe-service-life-cycle-microsoft-365/2-private-public-general-availability';

// Prebuilt demos section links
export const customTranslationDemoLink = 'https://portal.customtranslator.azure.ai';

// Project customization sections links
export const cluInfoLink = 'https://aka.ms/cluDocs';
export const qnaInfoLink = 'https://aka.ms/custom-qa';
export const extractInfoLink = 'https://aka.ms/extractInfoDocs';
export const classifyInfoLink = 'https://aka.ms/classifytextDocs';
export const translationInfoLink = 'https://aka.ms/lp-language-translation';
